import { Text } from "@ui-component-library";
import { TailwindWrapper } from "@utils/TailwindWrapper";

export const SubHeadingPosts = (props: { title?: string }) => {
  
    return (
        <TailwindWrapper>   
            <div className="mx-auto mb-6 flex max-w-[720px] flex-col px-4 sm:px-6">
                <Text variant="text-3xl/leading-normal/semibold">
                {props.title || "Heading posts"}
                </Text>
            </div>
        </TailwindWrapper> 
    );
  };

  SubHeadingPosts.fields = {
    title: {
        type: "text",
        label: "Title",
      },
}